var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var Pen = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "m5.14 16.86.63-4.36L15.8 2l4.25 4.25-10.5 10.03-4.4.58Zm2.16-3.68-.27 1.79 1.79-.27 8.98-8.5-1.95-1.94-8.55 8.92Zm-2.63 3.94H0v1.57h4.67v-1.57Z" }))); });
//# sourceMappingURL=Pen.js.map